$(function(){
  initSearchKeywords();
  initSearchSuggest();
});

function initSearchKeywords() {
  $(document).on('click', '.header-search-toggle', () => {
    requestSearchKeywords();
  });
}

const searchApiRoot = 'https://bflatapp.com/api/search';
const keywordCache = {};
const keywordRequests = {};
const suggestCache = {};
const suggestRequests = {};
let suggestDebounceTimer = null;
let latestSuggestQuery = '';

const buildKeywordUrl = keyword => {
  const params = new URLSearchParams();
  const brandId = window.brand_id;

  if (brandId !== undefined && brandId !== null && brandId !== '') {
    params.append('brandId', brandId);
  }

  params.append('keyword', keyword);

  return `/pages/products/all?${params.toString()}`;
};

const getKeywordEndpoint = () => {
  const brandId = window.brand_id;
  if (brandId) {
    return `${searchApiRoot}/brands/${encodeURIComponent(brandId)}/keywords`;
  }
  return `${searchApiRoot}/keywords`;
};

const ensureKeywordContainer = () => {
  const $content = $('.js-search-keywords');
  if (!$content.length) return null;

  let $wrapper = $content.find('.js-search-keywords-content');

  if (!$wrapper.length) {
    $wrapper = $('<div class="js-search-keywords-content tw-w-full tw-mt-6"></div>');
    const $form = $content.find('form').last();
    if ($form.length) {
      $wrapper.insertAfter($form);
    } else {
      $content.append($wrapper);
    }
  }

  return $wrapper;
};

const renderKeywordMessage = ($wrapper, message) => {
  $wrapper.empty().append(
    $('<p class="tw-text-xs tw-text-gray-500"></p>').text(message)
  );
};

const renderKeywordLoading = $wrapper => {
  const $spinner = $(`
    <svg width="18" height="18" viewBox="0 0 24 24" class="tw-text-gray-400" aria-hidden="true">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-dasharray="60"
        stroke-dashoffset="20"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 12 12"
          to="360 12 12"
          dur="0.8s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  `);

  $wrapper
    .empty()
    .append(
      $('<div class="tw-flex tw-justify-center tw-items-center tw-py-3"></div>')
        .append($spinner)
        // .append($('<span></span>').text('注目ワードを読み込み中...'))
    );
};

const ensureSuggestContainer = () => {
  const $content = $('.js-search-suggest');
  if (!$content.length) return null;

  let $wrapper = $content.find('.js-search-suggest-content');

  if (!$wrapper.length) {
    $wrapper = $('<div class="js-search-suggest-content tw-w-full tw-mt-6"></div>');
    $content.append($wrapper);
  }

  return $wrapper;
};

const hideSearchSuggestions = (options = {}) => {
  const { hideKeywords = false } = options;
  const $container = $('.js-search-suggest');
  if (!$container.length) return;

  $container.addClass('hidden');
  $container.find('.js-search-suggest-content').empty();

  if (hideKeywords) {
    $('.js-search-keywords').addClass('hidden');
  } else {
    $('.js-search-keywords').removeClass('hidden');
  }
};

const appendQueryParam = (url, key, value) => {
  try {
    const u = new URL(url, window.location.origin);
    u.searchParams.set(key, value);
    return u.pathname + (u.search ? u.search : '') + (u.hash || '');
  } catch (e) {
    const hasQuery = url.includes('?');
    const joiner = hasQuery ? '&' : '?';
    return `${url}${joiner}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }
};

const renderKeywords = ($wrapper, keywords) => {
  $wrapper.empty();

  const sortedKeywords = Array.isArray(keywords) ? [...keywords] : [];
  sortedKeywords.sort((a, b) => {
    const orderA = Number(a?.display_order ?? a?.dispaly_order ?? 9999);
    const orderB = Number(b?.display_order ?? b?.dispaly_order ?? 9999);
    return orderA - orderB;
  });

  const filteredKeywords = sortedKeywords.filter(item => item?.keyword);

  if (!filteredKeywords.length) {
    return;
  }

  const $heading = $('<p class="tw-text-sm tw-mb-2">注目のワード</p>');
  const $list = $('<ul class="tw-border-y tw-border-gray-200 tw-divide-y tw-divide-gray-200"></ul>');

  filteredKeywords.forEach((item, index) => {
    const keyword = item.keyword;
    const position = index + 1;
    const $link = $('<a class="tw-flex tw-items-center tw-gap-3 tw-py-3 tw-px-2 tw-text-xs tw-text-gray-800 hover:tw-bg-gray-100"></a>');
    // ▼ 追加：計測用
    $link.addClass('js-featured-word');
    $link.attr('data-word', keyword);
    $link.attr('data-position', String(position));
    $link.attr('data-brand-id', String(window.brand_id ?? ''));

    const $icon = $(`<svg xmlns="http://www.w3.org/2000/svg" style="color: #FF3E3E" width="16" height="16" fill="currentColor" class="bi bi-fire" viewBox="0 0 16 16"><path d="M8 16c3.314 0 6-2 6-5.5 0-1.5-.5-4-2.5-6 .25 1.5-1.25 2-1.25 2C11 4 9 .5 6 0c.357 2 .5 4-2 6-1.25 1-2 2.729-2 4.5C2 14 4.686 16 8 16m0-1c-1.657 0-3-1-3-2.75 0-.75.25-2 1.25-3C6.125 10 7 10.5 7 10.5c-.375-1.25.5-3.25 2-3.5-.179 1-.25 2 1 3 .625.5 1 1.364 1 2.25C11 14 9.657 15 8 15"/></svg>`);
    const $label = $('<span class="tw-flex-1"></span>').text(keyword);

    const keywordUrl = item.url || buildKeywordUrl(keyword);
    const onlyStockUrl = appendQueryParam(keywordUrl, 'stock', '1');
    $link.attr('href', onlyStockUrl);
    $link.append($icon, $label);

    $list.append($('<li></li>').append($link));
  });

  $wrapper.append($heading, $list);
};

const fetchKeywords = endpoint => {
  if (keywordCache[endpoint]) {
    return Promise.resolve(keywordCache[endpoint]);
  }

  if (keywordRequests[endpoint]) {
    return keywordRequests[endpoint];
  }

  keywordRequests[endpoint] = fetch(endpoint)
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch search keywords');
      }
      return response.json();
    })
    .then(data => {
      keywordCache[endpoint] = data;
      return data;
    })
    .catch(error => {
      console.error('Could not load search keywords', error);
      throw error;
    })
    .finally(() => {
      keywordRequests[endpoint] = null;
    });

  return keywordRequests[endpoint];
};

const requestSearchKeywords = () => {
  const $wrapper = ensureKeywordContainer();
  if (!$wrapper) return;

  const endpoint = getKeywordEndpoint();

    if (keywordCache[endpoint]) {
      renderKeywords($wrapper, keywordCache[endpoint]);
      return;
    }

    renderKeywordLoading($wrapper);

  fetchKeywords(endpoint)
    .then(keywords => {
      renderKeywords($wrapper, keywords);
    })
    .catch(() => {
      renderKeywordMessage($wrapper, '注目ワードを読み込めませんでした');
    });
};

const renderSearchSuggestions = suggestions => {
  const $wrapper = ensureSuggestContainer();
  if (!$wrapper) return;

  const items = Array.isArray(suggestions)
    ? suggestions
      .map(item => {
        if (typeof item === 'string') return item;
        if (item && typeof item.keyword === 'string') return item.keyword;
        return null;
      })
      .filter(Boolean)
    : [];

  if (!items.length) {
    const hasQuery = Boolean((latestSuggestQuery || '').trim());
    hideSearchSuggestions({ hideKeywords: hasQuery });
    return;
  }

  const $list = $('<ul class="tw-border-y tw-border-gray-200 tw-divide-y tw-divide-gray-200"></ul>');

  items.forEach(keyword => {
    const keywordUrl = appendQueryParam(buildKeywordUrl(keyword), 'stock', '1');
    const $link = $('<a class="tw-flex tw-items-center tw-gap-3 tw-py-3 tw-px-2 tw-text-xs tw-text-gray-800 hover:tw-bg-gray-100"></a>');
    const $icon = $(`
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="tw-text-gray-400">
        <circle cx="11" cy="11" r="7"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
    `);

    $link.attr('href', keywordUrl);
    $link.append($icon, $('<span class="tw-flex-1"></span>').text(keyword));
    $list.append($('<li></li>').append($link));
  });

  $wrapper.empty().append($list);
  $('.js-search-keywords').addClass('hidden');
  $('.js-search-suggest').removeClass('hidden');
};

const fetchSearchSuggestions = query => {
  if (suggestCache[query]) {
    return Promise.resolve(suggestCache[query]);
  }

  if (suggestRequests[query]) {
    return suggestRequests[query];
  }

  const params = new URLSearchParams();
  params.append('q', query);
  const endpoint = `${searchApiRoot}/suggest?${params.toString()}`;

  suggestRequests[query] = fetch(endpoint)
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch search suggestions');
      }
      return response.json();
    })
    .then(data => {
      const suggestions = Array.isArray(data?.suggestions) ? data.suggestions : [];
      suggestCache[query] = suggestions;
      return suggestions;
    })
    .catch(error => {
      console.error('Could not load search suggestions', error);
      throw error;
    })
    .finally(() => {
      suggestRequests[query] = null;
    });

  return suggestRequests[query];
};

const requestSearchSuggestions = query => {
  const trimmed = query.trim();
  if (!trimmed) {
    hideSearchSuggestions();
    return;
  }

  fetchSearchSuggestions(trimmed)
    .then(suggestions => {
      if (latestSuggestQuery !== trimmed) return;
      renderSearchSuggestions(suggestions);
    })
    .catch(() => {
      if (latestSuggestQuery === trimmed) {
        hideSearchSuggestions({ hideKeywords: true });
      }
    });
};

const scheduleSearchSuggestions = query => {
  latestSuggestQuery = query;

  if (suggestDebounceTimer) clearTimeout(suggestDebounceTimer);

  const trimmed = query.trim();
  if (!trimmed) {
    hideSearchSuggestions();
    return;
  }

  $('.js-search-keywords').addClass('hidden');

  suggestDebounceTimer = setTimeout(() => {
    requestSearchSuggestions(trimmed);
  }, 300);
};

function initSearchSuggest() {
  const $input = $('input[name="keyword"]');
  if (!$input.length) return;

  hideSearchSuggestions();

  $(document).on('input', 'input[name="keyword"]', e => {
    const query = e.target?.value || '';
    scheduleSearchSuggestions(query);
  });
}

const trackFeaturedWordClick = (e, el) => {
  if (typeof window.gtag !== 'function') return;

  const word = el.getAttribute('data-word') || '';
  const position = Number(el.getAttribute('data-position') || 0);
  const brandId = el.getAttribute('data-brand-id') || null;

  window.gtag('event', 'featured_word_click', {
    word,
    position,
    brand_id: brandId,
  });
};

// 動的DOMなので委譲で拾う
document.addEventListener('click', function (e) {
  const a = e.target.closest('a.js-featured-word');
  if (!a) return;

  trackFeaturedWordClick(e, a);
});
